import { useTranslation } from 'react-i18next';

import styles from './Header.module.scss';

const Header = () => {
  const { t } = useTranslation();
  return (
    <div className={styles['header']}>
      <div className={styles['header__title']}>
        {t('innerLayout.chargeBacks.title')}
      </div>
    </div>
  );
};

export default Header;
